import _ from "lodash"
import getInstance from "../../../../i18n/IntlInstance"
import colors from "./styleColors"
import { common } from "./styles"
import messages from "./messages"

function getResponsiveStyle() {
  // this is 5 iPhone width
  if (window.innerWidth <= 320) {
    return {
      spacing: 2,
      padding: 2,
      width: 30,
      fontSize: common.xsFontSize
    }
  }
  // this is 6/7/8 iPhone width
  if (window.innerWidth <= 375) {
    return {
      spacing: 2,
      padding: 2,
      width: 38,
      fontSize: common.xsFontSize
    }
  }
  if (window.innerWidth <= 680) {
    return {
      spacing: 4,
      padding: 4,
      width: 60,
      fontSize: common.sFontSize
    }
  }
  // this is Material-ui SM breakpoints
  if (window.innerWidth <= 840) {
    return {
      spacing: 4,
      padding: 4,
      width: 90,
      fontSize: common.mFontSize
    }
  }
  return {
    spacing: 5,
    padding: 6,
    width: 120,
    fontSize: common.mFontSize
  }
}

/**
 * Hard coded range buttons in webportal app
 */
function buildRangeSelectorButtons() {
  const intl = getInstance()
  return [
    {
      type: "year",
      count: 1,
      text: intl.formatMessage(messages.year, { count: 1 })
    },
    {
      type: "year",
      count: 3,
      text: intl.formatMessage(messages.year, { count: 3 })
    },
    {
      type: "year",
      count: 5,
      text: intl.formatMessage(messages.year, { count: 5 })
    },
    {
      type: "year",
      count: 8,
      text: intl.formatMessage(messages.year, { count: 8 })
    }
  ]
}

/**
 * Custom range selectors
 * See: com.jump.server.web.pattern.chart.highcharts.HighchartsRangeSelectorOption
 * See: https://www.highcharts.com/docs/stock/range-selector
 * See API docs: https://api.highcharts.com/highstock/rangeSelector
 * @param chartOpts
 * @returns {*}
 */
export default function montaigneRangeSelectorPlugin(chartOpts) {
  if (!chartOpts.rangeSelector) {
    return chartOpts
  }

  // _.unset(chartOpts, "rangeSelector.buttonPosition")
  _.unset(chartOpts, "rangeSelector.inputPosition")

  // translate buttons label
  // const buttons = translateRangeSelectorButtons(chartOpts.rangeSelector.buttons)
  const buttons = buildRangeSelectorButtons()
  _.set(chartOpts, "rangeSelector.buttons", buttons)
  _.set(chartOpts, "rangeSelector.labelStyle.display", "none")
  _.set(chartOpts, "rangeSelector.x", 0)
  _.set(chartOpts, "rangeSelector.y", 0)

  _.set(chartOpts, "rangeSelector.buttonPosition", {
    align: "right",
    x: -52,
    y: -12
  })
  const responsive = getResponsiveStyle()

  _.set(chartOpts, "rangeSelector.buttonSpacing", responsive.spacing)
  _.set(chartOpts, "rangeSelector.buttonTheme.padding", responsive.padding)
  _.set(chartOpts, "rangeSelector.buttonTheme.width", responsive.width)
  _.set(
    chartOpts,
    "rangeSelector.buttonTheme.stroke",
    colors.rangeSelectorButtonBackground
  )
  _.set(chartOpts, "rangeSelector.buttonTheme.stroke-width", 1)

  const style = {
    color: colors.textColor,
    fontSize: responsive.fontSize,
    fontFamily: common.fontFamily
  }
  _.set(chartOpts, "rangeSelector.buttonTheme.style", style)
  //
  // // custom states
  const states = {
    hover: {
      fill: colors.rangeSelectorButtonBackgroundHover,
      style: {
        color: colors.rangeSelectorButtonColor
      }
    },
    select: {
      fill: colors.rangeSelectorButtonBackgroundSelect,
      style: {
        color: colors.rangeSelectorButtonColor
      }
    }
  }
  _.set(chartOpts, "rangeSelector.buttonTheme.states", states)
  return chartOpts
}
